import React, { Component } from "react";
import { Form, Row, Col, Button, ListGroup, Nav } from "react-bootstrap";
import { browserHistory } from 'react-router'
import { LinkContainer } from "react-router-bootstrap";

import "containers/common/List.css";
import { API } from "aws-amplify";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import DatePicker from "react-datepicker";
import CreatableSelect from 'react-select/creatable';

export default class PropertyList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            dataSet: "properties",
            dataRecord: "properties",
            dataSetPrimaryKey: "property_id",
            properties: []
        };

        
        
        this.deleteProperty = this.deleteProperty.bind(this);
        this.handleDeleteProperty = this.handleDeleteProperty.bind(this);
    }
    

    async componentDidMount() {
        
        if (!this.props.isAuthenticated) { // if false
            return;
        }
        

        this.setState({ isLoading: true });
        
        
        

        this.setState({ isLoading: false });      
    }

    async componentDidUpdate(prevProps) {
        console.log("ComponentDidUpdate");
        

    }

    componentWillUnmount() {
        this.setState({ properties: [] });
    }

    
    

    deleteProperty(propertyKey) {
        return API.del("colin", "/properties", { 'queryStringParameters': propertyKey });
    };
    
    handleDeleteProperty = async event => {
        
        console.log(event);
      
        var r = window.confirm("Are you sure you want to delete this property?");
        if (r === true) {

            //Delete property
            await this.deleteProperty(event);

            //New search for properties using the existing filters
            this.setState({ isLoading: true });
           
               
            let properties = await this.get_properties(this.props.filter);               
            this.setState({ properties });
            this.setState({ isLoading: false });
            
            
        };
    };

    
    handleSave = async (cellInfo, event) => {

        this.setState({ showAlert: false });
        let data = [...this.props.data];        
        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }
        // if (data[0].hasOwnProperty("unit_sort")) {
        //     data.sort(function (a, b) { return a.unit_sort - b.unit_sort });
        // }
        if (data[0].hasOwnProperty("sort_order")) {
            data.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        this.props.updateTableState(data, this.state.dataSet);
    }




    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);
            
            

        } catch (e) {
            alert("Error saving");
        }
    }


    
    handleInputChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = val;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];


        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        // onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                // onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    // onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    // onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }



    renderTable(data) {
        const columns = [
            {
                id: 'selected',
                Header: '',
                maxWidth: 60,
                accessor: 'selected',
                Cell: this.renderEditable,
                style: { textAlign: "center" }
            },
            {
            id: 'property_key',
            Header: 'Cityscope Reference',
                accessor: 'property_key',
                Cell: e => <LinkContainer to={ {pathname: `/properties/${e.value}`, state: {data: this.props.data.filter((a) => { if(a.selected){return true;}else{return false;}} ).map(a => a.property_key)}}}><a>{e.value}</a></LinkContainer>,
                maxWidth: 75

        },{
            id: 'building_name', // Required because our accessor is not a string
            Header: 'Building Name',
            accessor: 'building_name',
            style: { 'white-space': 'unset' } 
            },
        {
            id: 'main_address',
            Header: 'Main Address',
            accessor: 'main_address',
            Cell: ({ value }) => String(value),
            maxWidth: 80,
            style: { 'white-space': 'unset' } 

        }, {
                id: 'street_num_low',
                Header: 'St No. Low',
                accessor: 'street_num_low',
                maxWidth: 100

            }, {
                id: 'street_num_low_suffix',
                Header: 'St No. Low Suffix',
                accessor: 'street_num_low_suffix',
                maxWidth: 75

            }, {
                id: 'street_num_high',
                Header: 'St No. High',
                accessor: 'street_num_high',
                maxWidth: 70

            }, {
                id: 'street_num_high_suffix',
                Header: 'St No. High Suffix',
                accessor: 'street_num_high_suffix',
                maxWidth: 75

            }, {
                id: 'street_name',
                Header: 'St Name',
                accessor: 'street_name',
                 style: { 'white-space': 'unset' } 

            }, {
                id: 'suburb',
                Header: 'Suburb',
                accessor: 'suburb',
                style: { 'white-space': 'unset' } 

            }, {
                id: 'state',
                Header: 'State',
                accessor: 'state',
                maxWidth: 75

            }, {
                id: 'postcode',
                Header: 'Postcode',
                accessor: 'postcode',
                maxWidth: 75

            }
            , {
                id: 'title_details',
                Header: 'Title',
                accessor: 'title_details',
                maxWidth: 300,
                style: { 'white-space': 'unset' } 

            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    sortable={false}
                    defaultPageSize={50}
                    
                    className="-striped -highlight"
                />
            )
        }



    }

    
    renderTable2(data) {
        const columns = [           
            {
            id: 'property_key',
            Header: 'Cityscope Reference',
                accessor: 'property_key',
                Cell: e => <LinkContainer to={ {pathname: `/properties/${e.value}`, state: {data: this.props.data.filter((a) => { if(a.selected){return true;}else{return false;}} ).map(a => a.property_key)}}}><a>{e.value}</a></LinkContainer>,
                maxWidth: 150

        },{
            id: 'building_name', // Required because our accessor is not a string
            Header: 'Building Name',
            accessor: 'building_name',
            style: { 'white-space': 'unset' } 
            },
        {
            id: 'main_address',
            Header: 'Main Address',
            accessor: 'main_address',
            Cell: ({ value }) => String(value),
            maxWidth: 80,
            style: { 'white-space': 'unset' } 

        }, {
                id: 'street_num_low',
                Header: 'St No. Low',
                accessor: 'street_num_low',
                maxWidth: 100

            }, {
                id: 'street_num_low_suffix',
                Header: 'St No. Low Suffix',
                accessor: 'street_num_low_suffix',
                maxWidth: 100

            }, {
                id: 'street_num_high',
                Header: 'St No. High',
                accessor: 'street_num_high',
                maxWidth: 100

            }, {
                id: 'street_num_high_suffix',
                Header: 'St No. High Suffix',
                accessor: 'street_num_high_suffix',
                maxWidth: 100

            }, {
                id: 'street_name',
                Header: 'St Name',
                accessor: 'street_name',
                 style: { 'white-space': 'unset' } 

            }, {
                id: 'suburb',
                Header: 'Suburb',
                accessor: 'suburb',
                style: { 'white-space': 'unset' } 

            }, {
                id: 'state',
                Header: 'State',
                accessor: 'state',
                maxWidth: 100

            }, {
                id: 'postcode',
                Header: 'Postcode',
                accessor: 'postcode',
                maxWidth: 100

            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    sortable={false}
                    defaultPageSize={50}
                    
                    className="-striped -highlight"
                />
            )
        }



    }

    //Modify the attribute shown in the list for each type of record
    renderList(data) {
        if (!data) {
            return null
        }
        else {
            return [{}].concat(data).map(
                (d, i) =>
                    i !== 0
                        ?
                        <ListGroup.Item key={i} as="a" header={d.property_key}>
                            {d.property_key + " " + d.street_name}
                        </ListGroup.Item>
                        : ""
            );
        }
    }

    selectAll = event =>{
        let data = [...this.props.data];
        for(var i=0;i<data.length;i++){
            data[i].selected=true;
        }
        this.props.updateTableState(data, this.state.dataSet);
    }

    deselectAll = event =>{
        let data = [...this.props.data];
        for(var i=0;i<data.length;i++){
            data[i].selected=false;
        }
        this.props.updateTableState(data, this.state.dataSet);
    }

    addToBrowseList = event =>{
      
        this.props.saveBrowseList();
    }

    

    renderComponent() {
        return (
            <div className="properties">
                              
                {this.props.controlType == "table" && 
                <div>
                <Row >
                <Col className="text-left" >
                <Nav className="justify-content-start"  >
                             <Nav.Item  >
                            <Button variant="primary" type="button" size="sm" onClick={this.selectAll}>Select All</Button>{" "}
                           </Nav.Item> <Nav.Item  >
                             <Button variant="primary" type="button" size="sm" onClick={this.deselectAll}>Deselect All</Button>{" "}
                             </Nav.Item> <Nav.Item  >
                             
                            <CreatableSelect
                                    value={this.props.selectedBrowseListOption}
                                    onChange={this.props.handleBrowseListChange}
                                    options={this.props.browseListsOptions}
                                    onCreateOption={this.props.handleBrowseListInputChange}
                                    placeholder="Select a Browse Lists"
                                    isClearable
                                    />
                                <Form.Control
                                as="input"
                                type="text"
                                style={{visibility: "hidden",
                                       padding: "0px 0px", 
                                       "line-height": "0px",
                                       "font-size": "0px",
                                       "width": "300px"
                            }}
                            /> 
                          </Nav.Item>
                          <Nav.Item  >
                            {" "}<Button variant="primary" type="button" size="sm" onClick={this.props.searchBrowseList}>Retrieve Browse List</Button>{" "}
                            </Nav.Item> 
                           <Nav.Item  >
                            <Button variant="primary" type="button" size="sm" onClick={this.props.saveBrowseList}>Add to Browse List</Button>{" "}
                            </Nav.Item> 

                           {this.props.selectedBrowseListOption && <Nav.Item  >
                            <Button variant="danger" type="button" size="sm" onClick={this.props.deleteBrowseList}>Delete Browse List</Button>{" "}
                           </Nav.Item> }
                           
                          </Nav>
               
                
                </Col>
                    <Col className="text-right" sm={4} md={3} lg={2}>
                            <LinkContainer to={`/properties/new`}>
                                <Button variant="primary" type="button" size="sm" >Add New Property</Button></LinkContainer>
    
                        </Col>
                </Row>
            <Row>
                <Col><b>{this.props.data?this.props.data.length: "0"} of {this.props.data? this.props.data.length>0 ? this.props.data[0].result_count: "0":"0"} records returned.</b></Col>
            </Row>
        </div>}

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading && this.props.controlType == "table" ? this.renderTable(this.props.data) : this.props.controlType == "table2" ? this.renderTable2(this.props.data) :this.renderList(this.props.data)}
                        </Col>
                    </Row>            
            </div>


        );
    }
  render() {
    return (
//force an update
        <div className="PropertyList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
        </div>
    );
  }
}
